import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export function initWhoChoose() {
  const parent = document.querySelector('.who-choose');
  if (!parent) return;

  const inner = parent.querySelector('.who-choose__bg');

  const animation = new ParticleWaveBackground(inner, {
    planeWidth: 12.996,
    planeHeight: 10.431,
    widthSegments: 174,
    heightSegments: 128,
    particleSize: 0.02808,
    waveHeight: 0.844,
    noiseScale: 2.4696,
    animationSpeed: 7569,
    fadePower: 0.7425,
    color: [0.9176470588235294, 0, 0.14901960784313725],
    bgColor: [0.9608, 0.9608, 0.9608],
    rotationX: -0.797964534011807,
    rotationY: 0.282743338823081,
    rotationZ: -0.0251327412287183,
    cameraPosition: [-3.04, -0.58, 10.431],
    cameraRotationX: 0,
    cameraRotationY: 0,
    cameraRotationZ: 0,
    autoStart: false,
  });

  ScrollTrigger.create({
    trigger: parent,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => animation.startAnimation(),
    onLeave: () => animation.stopAnimation(),
    onEnterBack: () => animation.startAnimation(),
    onLeaveBack: () => animation.stopAnimation(),
  });

  const cards = parent.querySelectorAll('.who-choose__card');
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });

    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });

    // Subtle continuous floating effect
    tl.to(
      card,
      {
        y: '-=3',
        duration: 2,
        yoyo: true,
        repeat: -1,
        ease: 'sine.inOut',
      },
      0,
    );
  });
}
